<div class="c-field-context-menu btn-group" dropdown>
  <label i18n="@@fieldContextMenu-label-menu">Menu</label>
  <button
    [attr.aria-controls]="ariaControlsId"
    class="btn btn-default dropdown-toggle text-start text-dark"
    [id]="buttonId"
    type="button"
    dropdownToggle
  >
    <i class="far fa-fw fa-ellipsis-v" aria-hidden="true"></i>
    <span class="sr-only" i18n="@@fieldContextMenu-button-menu">Menu</span>
  </button>
  <ng-container>
    <ul
      [attr.aria-labelledby]="buttonId"
      class="dropdown-menu dropdown-menu-end"
      [id]="ariaControlsId"
      role="menu"
      *dropdownMenu
    >
      <li role="menuitem" *ngIf="isRemoveFieldEnabled">
        <a
          class="dropdown-item c-field-context-menu__remove-field"
          role="button"
          (click)="triggerMenuOption(fieldContextMenuOption.REMOVE_FIELD)"
          i18n="@@fieldContextMenu-removeField"
          >Remove field</a
        >
      </li>
      <li role="menuitem" *ngIf="isMoveFieldToOtherPartEnabled">
        <a
          class="dropdown-item c-field-context-menu__move-field-to-other-part"
          role="button"
          (click)="
            triggerMenuOption(fieldContextMenuOption.MOVE_FIELD_TO_OTHER_PART)
          "
          i18n="@@fieldContextMenu-moveFieldToOtherPart"
          >Move field to other part</a
        >
      </li>
      <li role="menuitem" *ngIf="isMoveIndexUpEnabled">
        <a
          class="dropdown-item c-field-context-menu__move-index-up"
          role="button"
          (click)="triggerMenuOption(fieldContextMenuOption.MOVE_INDEX_UP)"
          i18n="@@fieldContextMenu-moveFieldUp"
          >Move field up</a
        >
      </li>
      <li role="menuitem" *ngIf="isMoveIndexDownEnabled">
        <a
          class="dropdown-item c-field-context-menu__move-index-down"
          role="button"
          (click)="triggerMenuOption(fieldContextMenuOption.MOVE_INDEX_DOWN)"
          i18n="@@fieldContextMenu-moveFieldDown"
          >Move field down</a
        >
      </li>
      <li role="menuitem" *ngIf="isSwapAuthorPartsEnabled">
        <a
          class="dropdown-item c-field-context-menu__swap-author-parts"
          role="button"
          (click)="triggerMenuOption(fieldContextMenuOption.SWAP_AUTHOR_PARTS)"
          i18n="@@fieldContextMenu-swapAuthorParts"
          >Swap author parts</a
        >
      </li>
      <li role="menuitem" *ngIf="isChangeAuthorToEditorEnabled">
        <a
          class="dropdown-item c-field-context-menu__change-author-to-editor"
          role="button"
          (click)="
            triggerMenuOption(fieldContextMenuOption.CHANGE_AUTHOR_TO_EDITOR)
          "
          i18n="@@fieldContextMenu-changeAuthorToEditor"
          >Change author to editor</a
        >
      </li>
      <li role="menuitem" *ngIf="isChangeEditorToAuthorEnabled">
        <a
          class="dropdown-item c-field-context-menu__change-editor-to-author"
          role="button"
          (click)="
            triggerMenuOption(fieldContextMenuOption.CHANGE_EDITOR_TO_AUTHOR)
          "
          i18n="@@fieldContextMenu-changeEditorToAuthor"
          >Change editor to author</a
        >
      </li>
    </ul>
  </ng-container>
</div>
